import { motion } from "framer-motion";
import { BRAND } from "@/constants/compliance";

const CHAPTERS = [
  {
    num: "01",
    title: `Text ${BRAND.keyword}`,
    body: `Send one keyword — ${BRAND.keyword} — to ${BRAND.number}. That single text is your explicit opt-in. No downloads, no accounts, no passwords. You instantly receive a welcome message confirming your subscription.`,
    tint: "group-hover:bg-[#D96B43]/5",
    accent: "text-[#D96B43]",
  },
  {
    num: "02",
    title: "Reminders arrive",
    body: "Automated task reminders and schedule updates land right in your messages — the app you already check a hundred times a day. Groceries at five, team sync in fifteen, meds at nine.",
    tint: "group-hover:bg-[#E5A93C]/10",
    accent: "text-[#E5A93C]",
  },
  {
    num: "03",
    title: "Help is one word",
    body: "Reply HELP at any moment and we will send you support information and your options. Humans on the other side, plain language only.",
    tint: "group-hover:bg-[#4A7C59]/5",
    accent: "text-[#4A7C59]",
  },
  {
    num: "04",
    title: "STOP means stop",
    body: "Reply STOP and every message ceases — immediately, permanently, no questions. Your consent is yours to give and yours to take back.",
    tint: "group-hover:bg-[#E89F8A]/15",
    accent: "text-[#E89F8A]",
  },
];

export const ManifestoChapters = () => (
  <section
    id="manifesto"
    data-testid="manifesto-section"
    className="relative bg-[#FAF8F5] py-24 sm:py-36 grain"
  >
    <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6 }}
        className="font-mono2 text-xs tracking-[0.25em] uppercase text-[#4A7C59] mb-4"
      >
        The manifesto
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, delay: 0.1 }}
        className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl text-[#1E2022] max-w-2xl leading-[1.08]"
        data-testid="manifesto-heading"
      >
        Productivity without the <span className="italic text-[#D96B43]">app clutter</span>.
      </motion.h2>

      <div className="mt-16 sm:mt-20 border-t border-[#1E2022]/10">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.num}
            data-testid={`manifesto-chapter-${c.num}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.08 }}
            className={`group grid sm:grid-cols-[140px_1fr_1.2fr] gap-4 sm:gap-10 items-baseline py-10 sm:py-12 border-b border-[#1E2022]/10 px-2 sm:px-4 transition-colors duration-500 ${c.tint}`}
          >
            <span className={`font-display font-extrabold text-5xl sm:text-6xl tracking-tighter ${c.accent} opacity-90`}>
              {c.num}
            </span>
            <h3 className="font-display font-bold text-2xl sm:text-3xl tracking-tight text-[#1E2022]">
              {c.title}
            </h3>
            <p className="text-base text-[#575B60] leading-relaxed max-w-lg">
              {c.body}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
